export default "__VITE_ASSET__CZvHOGg$__"